document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('[data-klaviyo-form]');
  if (!form) return;

  var publicKey = form.getAttribute('data-public-key') || window.KLAVIYO_PUBLIC_KEY;
  var listId = form.getAttribute('data-list-id') || window.KLAVIYO_LIST_ID;
  var emailInput = form.querySelector('[data-klaviyo-email]');
  var submitBtn = form.querySelector('[data-klaviyo-submit]');
  var messageEl = document.querySelector('[data-klaviyo-message]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!publicKey || !listId) {
      if (messageEl) {
        messageEl.textContent = 'Signup is not configured yet.';
        messageEl.hidden = false;
      }
      return;
    }

    var email = emailInput.value.trim();
    if (!email) return;

    submitBtn.disabled = true;
    var originalLabel = submitBtn.textContent;
    submitBtn.textContent = '...';

    var profileAttrs = { email: email };
    if (window.fantasyAveKlaviyoAnonId) {
      var anonId = window.fantasyAveKlaviyoAnonId();
      if (anonId) profileAttrs.anonymous_id = anonId;
    }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + publicKey, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttrs,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: listId }
            }
          }
        }
      })
    })
      .then(function (res) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        if (res.ok || res.status === 202) {
          form.hidden = true;
          if (messageEl) {
            messageEl.textContent = "You're on the list. Watch your inbox before the next drop.";
            messageEl.hidden = false;
          }
        } else {
          if (messageEl) {
            messageEl.textContent = 'Something went wrong, please try again.';
            messageEl.hidden = false;
          }
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        if (messageEl) {
          messageEl.textContent = 'Something went wrong, please try again.';
          messageEl.hidden = false;
        }
      });
  });
});
